import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import imgCheckLargeBMW from '../../assets/images/check-large-bmw.png';
import imgCheckLargeMINI from '../../assets/images/check-large-mini.png';
import cssForms from '../../assets/scss/Forms.scss';
import { config } from '../../common';
import TopNav from '../../main/components/TopNav';
import css from './SurveyFollowup.scss';

interface SurveyFollowupConfirmProps {
    name: string;
    email: string;
}

const SurveyFollowupConfirm: React.FC<SurveyFollowupConfirmProps> = (containerProps) => {
    const { t } = useTranslation();
    return (
        <div className={css.surveyfollowup}>
            <TopNav
                items={[
                    {
                        to: `${config.UnauthBaseUrl}`,
                        label: t('breadcrumbs.init'),
                    },
                    {
                        to: '#',
                        label: t('breadcrumbs.confirm'),
                    },
                ]}
            />
            <div className={css.container} id="surveyfollowup-confirmation-section">
                <div className={cssForms.sections}>
                    <div id={cssForms.topSections}>
                        <section className={[cssForms.textSection, cssForms.rem, 'text-success'].join(' ')}>
                            <div className={cssForms.textSectionWrapper}>
                                <h3>{t(`surveyfollowup:surveyfollowupConfirm.header1`)}</h3>
                                <div className={css.confirmHeader}>
                                    <img src={config.BrandEnv === 'BMW' ? imgCheckLargeBMW : imgCheckLargeMINI} />
                                    <h1>{t('surveyfollowup:surveyfollowupConfirm.header2')}</h1>
                                </div>
                                <p>
                                    {t('surveyfollowup:surveyfollowupConfirm.text1')} {containerProps.name},
                                    <br />
                                    {t('surveyfollowup:surveyfollowupConfirm.text2')} ({containerProps.email}).
                                    <br />
                                    {t('surveyfollowup:surveyfollowupConfirm.text3')}
                                </p>
                                <div className={[cssForms.buttons, 'col-12'].join(' ')}>
                                    <Link to={`${config.BaseURL}`} className={cssForms.width100} ><div className={[cssForms.bmwButton, cssForms.blue, cssForms.submit].join(' ')}>{t('surveyfollowup:surveyfollowupConfirm.closeBtn')}</div></Link>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SurveyFollowupConfirm;
